// src/pages/TrainerGroupsPage.jsx
import React, { useEffect, useMemo, useState } from 'react';
import BackToDashboardBtn from '../components/TrainerDashboard/BackToDashboardBtn';
import { useTranslation } from '../i18n';
import axios from 'axios';
import GroupsPanel from '../components/TrainerDashboard/GroupsPanel';
import API_BASE_URL from '../config/api';

const API_BASE =
  process.env.REACT_APP_API_BASE ||
  (typeof window !== 'undefined' && window.__CONFIG__ && window.__CONFIG__.API_BASE) ||
  `${API_BASE_URL}/api`;

const api = axios.create({ baseURL: API_BASE, withCredentials: true, timeout: 15000 });

api.interceptors.request.use((cfg) => {
  if (typeof cfg.url === 'string') {
    cfg.url = cfg.url.replace(/^\/trainer\//, '/trainers/');
  }
  return cfg;
});

export default function TrainerGroupsPage() {
  const { t } = useTranslation();
  const [athletes, setAthletes] = useState([]);
  const trainerId = useMemo(() => localStorage.getItem('userId') || '', []);

  useEffect(() => {
    if (!trainerId) return;
    const ctrl = new AbortController();
    (async () => {
      try {
        const { data } = await api.get(`/activities/trainer/${trainerId}/athletes`, { signal: ctrl.signal });
        setAthletes(Array.isArray(data) ? data : []);
      } catch {
        setAthletes([]);
      }
    })();
    return () => ctrl.abort();
  }, [trainerId]);

  return (
    <div className="container py-3">
      <div style={{ marginBottom: 16 }}><BackToDashboardBtn /></div>
      <h2 className="mb-3">{t('common.athleteGroup')}</h2>
      <GroupsPanel trainerId={trainerId} athletes={athletes} onSelect={() => {}} standalone />
    </div>
  );
}
